__turbopack_context__.v({
  "error-text": "Select-module-scss-module__OEswBa__error-text",
  "error-text-appear": "Select-module-scss-module__OEswBa__error-text-appear",
  "icon-container": "Select-module-scss-module__OEswBa__icon-container",
  "option": "Select-module-scss-module__OEswBa__option",
  "select": "Select-module-scss-module__OEswBa__select",
});
